import { ReactiveFormHostState } from './reactive-form-host-state';

export interface ReactiveFormHostReadinessSnapshot {
    readonly formReady: boolean;
    readonly dropdownsReady: boolean;
    readonly repeatablesReady: boolean;
    readonly minTimeExhausted: boolean;
    readonly ready: boolean;
    readonly hydrationReady: boolean;
}

export interface ReactiveFormHostReadinessCoordinatorOptions<TModel> {
    readonly state: ReactiveFormHostState<TModel>;
    readonly requireRepeatables?: boolean | undefined;
    readonly requireMinimumReadyTime?: boolean | undefined;
}

/** Coordinates generic host readiness flags without knowing application submit or navigation flows. */
export class ReactiveFormHostReadinessCoordinator {
    public static markFormReady<TModel>(state: ReactiveFormHostState<TModel>): void {
        state.markFormReady();
    }

    public static markRepeatablesReady<TModel>(state: ReactiveFormHostState<TModel>): void {
        state.markRepeatablesReady();
    }

    public static resetFormReady<TModel>(state: ReactiveFormHostState<TModel>): void {
        state.resetFormReady();
    }

    public static resetRepeatablesReady<TModel>(state: ReactiveFormHostState<TModel>): void {
        state.resetRepeatablesReady();
    }

    public static snapshot<TModel>(options: ReactiveFormHostReadinessCoordinatorOptions<TModel>): ReactiveFormHostReadinessSnapshot {
        const requireRepeatables = options.requireRepeatables ?? true;
        const requireMinimumReadyTime = options.requireMinimumReadyTime ?? true;
        const formReady = options.state.formReady;
        const dropdownsReady = options.state.dropdownsReady;
        const repeatablesReady = !requireRepeatables || options.state.repeatablesReady;
        const minTimeExhausted = !requireMinimumReadyTime || options.state.minTimeExhausted;
        const hydrationReady = formReady && dropdownsReady && repeatablesReady;

        return {
            formReady,
            dropdownsReady,
            repeatablesReady,
            minTimeExhausted,
            hydrationReady,
            ready: hydrationReady && minTimeExhausted,
        };
    }
}
